import { SecondaryTaskStatus, TaskStatus } from './constants';
import modifySvg from 'common/assets/icon/modify.svg';

export const ActivityTaskMenu: Record<string, { text: string; className: string; icon: any; iconSelected: any }> = {
  [SecondaryTaskStatus.Processing]: {
    text: '待提交',
    className: 'task-status-processing',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
  [SecondaryTaskStatus.PendingInternalCheck]: {
    text: '待审核',
    className: 'task-status-processing',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
  [SecondaryTaskStatus.PendingIterate]: {
    text: '待修改',
    className: 'task-status-processing',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
  [SecondaryTaskStatus.Pass]: {
    text: '待通过',
    className: 'task-status-processing',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
  [TaskStatus.Accepted]: {
    text: '待结算',
    className: 'task-status-pass',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
  [TaskStatus.Settling]: {
    text: '结算中',
    icon: modifySvg,
    className: 'settling',
    iconSelected: modifySvg,
  },
  [TaskStatus.End]: {
    text: '已结束',
    className: 'task-status-pass',
    icon: modifySvg,
    iconSelected: modifySvg,
  },
};

export type ActivityTask = {
  groupId: number;
  groupName: string;
  activityId: number;
  activityStartTime: string;
  activityEndTime: string;
  parentTasks: ParentTask[];
  activityCode: string; // 活动code
};
